import { ChangeDetectorRef, Injectable } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';

@Injectable({ providedIn: 'root' })
export class CdService {
    private cdLine: ChangeDetectorRef[] = [];

    constructor(private timeoutService: TimeoutService) {}

    push(ref: ChangeDetectorRef) {
        if (!this.cdLine.includes(ref)) {
            this.cdLine.push(ref);
            this.processCdLine();
        }
    }

    private processCdLine = this.timeoutService.debounce(() => {
        let cd: ChangeDetectorRef | undefined;
        while ((cd = this.cdLine.pop())) {
            cd.detectChanges();
        }
    }, 100);
}
